// Implements: F-CNV-015, F-VER-006, F-CNV-003
/**
 * Everything a moved "current version" makes stale, marked stale together.
 *
 * The pointer moves in three ways (a turn that wrote a version, a promote, a continue from
 * an earlier version) and each of them changes the same six reads: the mockup (which
 * version is current), the version tree, the thread (the message that records the move),
 * the conversation state, the gallery card and the gallery tab counts (mockup v3 P8). One
 * list, so a read added later is added once. It lives in `shared/api` because `conversation` and `versions` both need it and
 * a module may not import another.
 *
 * The promise settles when the refetches of the active queries do; a caller that must not
 * wait for them (the answer to a click) simply does not await it.
 */

import type { QueryClient } from "@tanstack/react-query";

import {
  GALLERY_COUNTS_KEY,
  MOCKUPS_KEY,
  conversationMessagesKey,
  conversationStateKey,
  mockupDetailKey,
  versionTreeKey,
} from "./queryKeys";

export async function invalidateMockupPointer(
  queryClient: QueryClient,
  mockupId: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: mockupDetailKey(mockupId) }),
    queryClient.invalidateQueries({ queryKey: versionTreeKey(mockupId) }),
    queryClient.invalidateQueries({ queryKey: conversationMessagesKey(mockupId) }),
    queryClient.invalidateQueries({ queryKey: conversationStateKey(mockupId) }),
    queryClient.invalidateQueries({ queryKey: MOCKUPS_KEY }),
    queryClient.invalidateQueries({ queryKey: GALLERY_COUNTS_KEY }),
  ]);
}
